// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme-color1-back: #1976d2;
  --theme-color1-front: #dadada;
  --theme-color1-button: #1976d2;
  --theme-color1-buttonhover: #115293;
  --theme-color1-border: #dadada80;
  --theme-color1-hover: #dadadaA0;
  --theme-front1: #333;
  --theme-front2: #494949;
  --theme-back1: #ececec;
  --theme-back2: #c8c8c8;
  --theme-border1: #c8c8c8;
  --theme-border2: #ffffff;
  --theme-selection: #324c8730;
  --theme-hover: #32497C30;
  --scrollbar-color-thumb: #afafaf;
  --scrollbar-color-track: #ececec;
  --link-color: #0942b3;
  --link-hover-color: #0749cc;
  --resource-icon-size: 80px; }

.theme-dark {
  --theme-color1-back: #272a3c;
  --theme-color1-front: #dcdcdc;
  --theme-color1-button: #2c3151;
  --theme-color1-buttonhover: #343b63;
  --theme-color1-border: rgba(181, 181, 181, 0.5);
  --theme-color1-hover: #FFFFFF30;
  --theme-front1: #e6e6e6;
  --theme-front2: #afafaf;
  --theme-back1: #222;
  --theme-back2: #444;
  --theme-border1: #444;
  --theme-border2: #2c2c2c;
  --theme-selection: #4f75d330;
  --theme-hover: #5072C530;
  --scrollbar-color-thumb: #6a6a6a;
  --scrollbar-color-track: #292929;
  --link-color: #4478cc;
  --link-hover-color: #1e63ff; }

/* MUI color overrides */
/*
.mainApp {
  .MuiAppBar-root {
    background-color: var(--theme-color1-back);
  }
  .MuiButton-root {
    &:hover {
      background-color: var(--theme-color1-buttonhover);
    }
    background-color: var(--theme-color1-button);
    color: var(--theme-color1-front);
  }
  .MuiInputBase-root {
    background-color: var(--theme-color1-button);
    color: var(--theme-color1-front);
  }
}

 */
body {
  margin: 0;
  padding: 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 1rem; }

.mainApp {
  height: 100vh;
  background: var(--theme-back1);
  color: var(--theme-front1);
  scrollbar-color: var(--scrollbar-color-thumb) var(--scrollbar-color-track);
  scrollbar-width: thin;
  /**
  Material UI overrides
  */ }
  .mainApp a:link {
    color: var(--link-color);
    text-decoration: none; }
  .mainApp a:visited {
    color: var(--link-color); }
  .mainApp a:hover {
    color: var(--link-hover-color);
    text-decoration: underline; }
  .mainApp a:active {
    color: var(--link-hover-color); }
  .mainApp .MuiInputBase-root {
    background-color: var(--theme-color1-button);
    color: var(--theme-color1-front); }
  .mainApp .MuiButtonGroup-root > .MuiInputBase-root:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  .mainApp .MuiButtonGroup-root > .MuiInputBase-root:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .mainApp .MuiTabPanel-root {
    padding: 0; }

.contentPane > * {
  height: 100%; }

.navbar {
  padding: 5px; }

.paddedPanel, .podbrowser .scan-results, .itemsTable .itemsList, .itemsTable .itemsDetails, .receiptsTable {
  padding: 15px; }

.fill {
  height: 100%;
  width: 100%;
  position: relative; }

.hFlow, .podbrowser .podbrowser-body, .itemsTable {
  display: flex;
  flex-direction: row; }
  .hFlow > *, .podbrowser .podbrowser-body > *, .itemsTable > * {
    flex: 1;
    min-width: 0;
    overflow: auto; }

.vFlow, .retail, .podbrowser .podbrowser-body .podbrowser-sidenav, .podbrowser .podbrowser-body .podbrowser-resource-viewer {
  flex-direction: column; }
  .vFlow:not([hidden]), .retail:not([hidden]), .podbrowser .podbrowser-body .podbrowser-sidenav:not([hidden]), .podbrowser .podbrowser-body .podbrowser-resource-viewer:not([hidden]) {
    display: flex; }
  .vFlow > *, .retail > *, .podbrowser .podbrowser-body .podbrowser-sidenav > *, .podbrowser .podbrowser-body .podbrowser-resource-viewer > * {
    flex: 1;
    overflow: auto;
    min-height: 0; }
  .vFlow .navbar, .retail .navbar, .podbrowser .podbrowser-body .podbrowser-sidenav .navbar, .podbrowser .podbrowser-body .podbrowser-resource-viewer .navbar {
    flex: none; }

.absolute-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 5px;
  overflow: auto; }

.react-codemirror2 {
  height: 100% !important; }

.CodeMirror {
  height: 100% !important;
  width: auto; }

.sidenav {
  flex: none;
  background-color: var(--theme-color1-back);
  border-right: 1px solid #13284a;
  padding: 5px; }
  .sidenav .sidenav-divider {
    margin: 5px 0px;
    border-bottom-width: 1px;
    border-color: var(--theme-color1-border); }
  .sidenav > button {
    display: block;
    border-radius: 10%;
    margin: 1px;
    color: var(--theme-color1-front); }
    .sidenav > button[aria-selected="true"] {
      box-shadow: inset 0px 0px 6px 2px var(--theme-color1-border); }
    .sidenav > button:hover {
      box-shadow: inset 0px 0px 6px 4px var(--theme-color1-hover); }

svg {
  vertical-align: middle; }

.retail .dataproviders {
  flex: none;
  height: 100px; }
  .retail .dataproviders .providerCard {
    position: relative;
    overflow: clip;
    background: var(--theme-back1);
    margin: 5px;
    padding: 3px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
    border: 1px solid var(--theme-back2);
    border-radius: 3px;
    max-width: 200px; }
    .retail .dataproviders .providerCard:hover {
      border: 1px solid #234087;
      box-shadow: 3px 3px 3px rgba(0, 0, 113, 0.5); }
    .retail .dataproviders .providerCard.selected {
      height: 110px;
      border: 1px solid #324c87;
      border-radius: 3px 3px 0px 0px;
      border-bottom: none;
      box-shadow: 3px 3px 3px rgba(0, 0, 113, 0.29);
      z-index: -1; }

.retail .uploader {
  background: var(--theme-back1);
  margin: 5px;
  padding: 3px;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--theme-back2);
  border-radius: 3px;
  z-index: 10; }

.podbrowser .scan-results table {
  border: 1px solid var(--theme-back2); }

.podbrowser .topbar {
  flex: none;
  background-color: var(--theme-back1);
  border-bottom: 1px solid var(--theme-back2); }
  .podbrowser .topbar .filebreadcrumb {
    display: inline-block;
    color: var(--theme-front1);
    border-radius: 2px;
    background-color: var(--theme-back2);
    border: 1px solid var(--theme-back2);
    margin: 3px;
    padding: 0px 3px; }
  .podbrowser .topbar .file_actions {
    display: inline-block;
    float: right; }

.podbrowser .podbrowser-body .podbrowser-sidenav {
  flex: 0.5;
  padding: 8px;
  border-right: 1px solid var(--theme-border1); }
  .podbrowser .podbrowser-body .podbrowser-sidenav .podbrowser-sidenav-quicklinks {
    flex: none;
    border-bottom: 1px solid var(--theme-border2);
    padding-bottom: 5px;
    margin-bottom: 5px; }
    .podbrowser .podbrowser-body .podbrowser-sidenav .podbrowser-sidenav-quicklinks > *:hover {
      background-color: var(--theme-hover); }
  .podbrowser .podbrowser-body .podbrowser-sidenav .podbrowser-tree .podbrowser-tree-children {
    margin-left: 10px; }
  .podbrowser .podbrowser-body .podbrowser-sidenav .podbrowser-tree .podbrowser-tree-resource-name > * {
    vertical-align: middle; }

.podbrowser .podbrowser-body .podbrowser-resource-viewer {
  flex: 2;
  border-right: 1px solid var(--theme-back2); }
  .podbrowser .podbrowser-body .podbrowser-resource-viewer .container-viewer.details .resource svg {
    margin-right: 5px; }
  .podbrowser .podbrowser-body .podbrowser-resource-viewer .container-viewer.grid {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    align-content: baseline; }
    .podbrowser .podbrowser-body .podbrowser-resource-viewer .container-viewer.grid .resource {
      text-align: center;
      height: 110px;
      padding: 3px; }
      .podbrowser .podbrowser-body .podbrowser-resource-viewer .container-viewer.grid .resource svg {
        font-size: var(--resource-icon-size);
        display: block; }
      .podbrowser .podbrowser-body .podbrowser-resource-viewer .container-viewer.grid .resource div {
        font-size: 15px;
        max-width: var(--resource-icon-size);
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        height: 30px; }

.podbrowser .podbrowser-body .acrPolicies, .podbrowser .podbrowser-body .acrMatchers {
  font-size: 80%; }
  .podbrowser .podbrowser-body .acrPolicies th, .podbrowser .podbrowser-body .acrMatchers th {
    text-align: center; }
  .podbrowser .podbrowser-body .acrPolicies td, .podbrowser .podbrowser-body .acrMatchers td {
    max-width: 2em; }
  .podbrowser .podbrowser-body .acrPolicies .MuiCheckbox-root, .podbrowser .podbrowser-body .acrMatchers .MuiCheckbox-root {
    padding: 0; }
  .podbrowser .podbrowser-body .acrPolicies .policyName, .podbrowser .podbrowser-body .acrMatchers .policyName {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap; }
  .podbrowser .podbrowser-body .acrPolicies .policyMatchers, .podbrowser .podbrowser-body .acrMatchers .policyMatchers {
    padding-left: 15px; }
  .podbrowser .podbrowser-body .acrPolicies .matcherName, .podbrowser .podbrowser-body .acrMatchers .matcherName {
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
    text-wrap: nowrap; }

.podbrowser .resource:hover {
  background-color: var(--theme-hover); }

.podbrowser .resource.selected {
  background-color: var(--theme-selection); }

.itemsTable .itemsList {
  flex: 1; }
  .itemsTable .itemsList > div {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
    .itemsTable .itemsList > div:hover {
      background-color: var(--theme-hover); }
    .itemsTable .itemsList > div.selected {
      background-color: var(--theme-selection); }

.itemsTable .itemsDetails {
  flex: 3; }

.frequencyBar {
  display: inline-block;
  border: 1px solid var(--theme-border1);
  position: relative;
  vertical-align: middle;
  margin: 2px 5px; }
  .frequencyBar > div {
    display: inline-block;
    background-color: green;
    height: 100%; }

.itemDate {
  display: inline-block;
  font-size: 90%;
  color: var(--theme-front2);
  margin: 2px 5px; }
`, "",{"version":3,"sources":["webpack://./src/solidbench.scss"],"names":[],"mappings":"AACA;EACE,4BAAoB;EACpB,6BAAqB;EACrB,8BAAsB;EACtB,mCAA2B;EAC3B,gCAAsB;EACtB,+BAAqB;EACrB,oBAAe;EACf,uBAAe;EACf,sBAAc;EACd,sBAAc;EACd,wBAAgB;EAChB,wBAAgB;EAChB,4BAAkB;EAClB,wBAAc;EAEd,gCAAwB;EACxB,gCAAwB;EAExB,qBAAa;EACb,2BAAmB;EAEnB,0BAAqB,EAAA;;AAMvB;EACE,4BAAoB;EACpB,6BAAqB;EACrB,8BAAsB;EACtB,mCAA2B;EAC3B,+CAAsB;EACtB,+BAAqB;EACrB,uBAAe;EACf,uBAAe;EACf,mBAAc;EACd,mBAAc;EACd,qBAAgB;EAChB,wBAAgB;EAChB,4BAAkB;EAClB,wBAAc;EAEd,gCAAwB;EACxB,gCAAwB;EAExB,qBAAa;EACb,2BAAmB,EAAA;;AAGrB,wBAAA;AACA;;;;;;;;;;;;;;;;;;EAOE;AAkBF;EACE,SAAS;EACT,UAAU;EAEV,uDAAuD;EACvD,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,aAAa;EAIb,8BAA8B;EAC9B,0BAA0B;EAE1B,0EAA0E;EAC1E,qBAAqB;EAUrB;;GA9BC,EAgCC;EArBJ;IAYa,wBAAwB;IAAE,qBAAqB,EAAA;EAZ5D;IAagB,wBAAwB,EAAA;EAbxC;IAcc,8BAA8B;IAAE,0BAA0B,EAAA;EAdxE;IAee,8BAA8B,EAAA;EAf7C;IAwBI,4CAA4C;IAC5C,gCAAgC,EAAA;EAzBpC;IA8BM,yBAAyB;IACzB,4BAA4B,EAAA;EA/BlC;IAmCM,0BAA0B;IAC1B,6BAA6B,EAAA;EApCnC;IA0CI,UAAU,EAAA;;AAMd;EAGI,YAAY,EAAA;;AAIhB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa,EAAA;;AAGf;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB,EAAA;EAFrB;IAKI,OAAO;IACP,YAAY;IACZ,cAAc,EAAA;;AAIlB;EAKE,sBAAsB,EAAA;EALxB;IAEI,aAAa,EAAA;EAFjB;IASI,OAAO;IACP,cAAc;IACd,aAAa,EAAA;EAXjB;IAeI,UAAU,EAAA;;AAKd;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,cAAc,EAAA;;AAGhB;EACE,uBAAuB,EAAA;;AAGzB;EAEE,uBAAuB;EACvB,WAAW,EAAA;;AAGb;EACE,UAAU;EACV,0CAA0C;EAC1C,+BAAuC;EACvC,YAAY,EAAA;EAJd;IAOI,eAAe;IACf,wBAAwB;IACxB,wCAAwC,EAAA;EAT5C;IAcI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gCAAgC,EAAA;IAjBpC;MAoBM,4DAA4D,EAAA;IApBlE;MAwBM,2DAA2D,EAAA;;AAKjE;EACE,sBAAsB,EAAA;;AAGxB;EAII,UAAU;EACV,aAAa,EAAA;EALjB;IAQM,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB,EAAA;IAhBtB;MAmBQ,yBAAyB;MACzB,4CAA4C,EAAA;IApBpD;MAwBQ,aAAa;MACb,yBAAyB;MACzB,8BAA8B;MAC9B,mBAAmB;MACnB,6CAA6C;MAC7C,WAAW,EAAA;;AA7BnB;EAmCI,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,WAAW,EAAA;;AAIf;EAKM,oCAAoC,EAAA;;AAL1C;EAUI,UAAU;EAEV,oCAAoC;EACpC,2CAA2C,EAAA;EAb/C;IAgBM,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,oCAAoC;IACpC,oCAAoC;IACpC,WAAW;IACX,gBAAgB,EAAA;EAtBtB;IA0BM,qBAAqB;IACrB,YAAY,EAAA;;AA3BlB;EAoCM,SAAS;EACT,YAAY;EACZ,4CAA4C,EAAA;EAtClD;IA6CQ,UAAU;IACV,6CAA6C;IAC7C,mBAAmB;IACnB,kBAAkB,EAAA;IAhD1B;MA0CU,oCAAoC,EAAA;EA1C9C;IAqDU,iBAAiB,EAAA;EArD3B;IA0DY,sBAAsB,EAAA;;AA1DlC;EAkEM,OAAO;EACP,0CAA0C,EAAA;EAnEhD;IAwEY,iBAAiB,EAAA;EAxE7B;IA6EU,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB,EAAA;IAhFjC;MAmFY,kBAAkB;MAClB,aAAa;MACb,YAAY,EAAA;MArFxB;QAwFc,oCAAoC;QACpC,cAAc,EAAA;MAzF5B;QA6Fc,eAAe;QACf,oCAAoC;QACpC,gBAAgB;QAChB,uBAAuB;QACvB,qBAAqB;QACrB,YAAY,EAAA;;AAlG1B;EA4GM,cAAc,EAAA;EA5GpB;IA+GQ,kBAAkB,EAAA;EA/G1B;IAoHQ,cAAc,EAAA;EApHtB;IAwHQ,UAAU,EAAA;EAxHlB;IA4HQ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB,EAAA;EA/HzB;IAmIQ,kBAAkB,EAAA;EAnI1B;IAuIQ,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB,EAAA;;AA5IzB;EAmJM,oCAAoC,EAAA;;AAnJ1C;EAuJM,wCAAwC,EAAA;;AAM9C;EAKI,OAAO,EAAA;EALX;IAQM,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB,EAAA;IAV7B;MAaQ,oCAAoC,EAAA;IAb5C;MAiBQ,wCAAwC,EAAA;;AAjBhD;EAwBI,OAAO,EAAA;;AASX;EACE,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe,EAAA;EALjB;IAQI,qBAAqB;IACrB,uBAAuB;IACvB,YAAY,EAAA;;AAIhB;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,eAAe,EAAA","sourcesContent":["\n:root {\n  --theme-color1-back: #1976d2;\n  --theme-color1-front: #dadada;\n  --theme-color1-button: #1976d2;\n  --theme-color1-buttonhover: #115293;\n  --theme-color1-border: #dadada80;\n  --theme-color1-hover: #dadadaA0;\n  --theme-front1: #333;\n  --theme-front2: #494949;\n  --theme-back1: #ececec;\n  --theme-back2: #c8c8c8;\n  --theme-border1: #c8c8c8;\n  --theme-border2: #ffffff;\n  --theme-selection: #324c8730;\n  --theme-hover: #32497C30;\n\n  --scrollbar-color-thumb: #afafaf;\n  --scrollbar-color-track: #ececec;\n\n  --link-color: #0942b3;\n  --link-hover-color: #0749cc;\n\n  --resource-icon-size: 80px;\n\n\n}\n\n\n.theme-dark {\n  --theme-color1-back: #272a3c;\n  --theme-color1-front: #dcdcdc;\n  --theme-color1-button: #2c3151;\n  --theme-color1-buttonhover: #343b63;\n  --theme-color1-border: rgba(181, 181, 181, 0.5);\n  --theme-color1-hover: #FFFFFF30;\n  --theme-front1: #e6e6e6;\n  --theme-front2: #afafaf;\n  --theme-back1: #222;\n  --theme-back2: #444;\n  --theme-border1: #444;\n  --theme-border2: #2c2c2c;\n  --theme-selection: #4f75d330;\n  --theme-hover: #5072C530;\n\n  --scrollbar-color-thumb: #6a6a6a;\n  --scrollbar-color-track: #292929;\n\n  --link-color: #4478cc;\n  --link-hover-color: #1e63ff;\n}\n\n/* MUI color overrides */\n/*\n.mainApp {\n  .MuiAppBar-root {\n    background-color: var(--theme-color1-back);\n  }\n  .MuiButton-root {\n    &:hover {\n      background-color: var(--theme-color1-buttonhover);\n    }\n    background-color: var(--theme-color1-button);\n    color: var(--theme-color1-front);\n  }\n  .MuiInputBase-root {\n    background-color: var(--theme-color1-button);\n    color: var(--theme-color1-front);\n  }\n}\n\n */\n\n\n\n\n$primary: var(--theme-color1-back);\n\nbody {\n  margin: 0;\n  padding: 0;\n\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n}\n\n.mainApp {\n  height: 100vh;\n  //width: 100%;\n  //position: absolute;\n\n  background: var(--theme-back1);\n  color: var(--theme-front1);\n\n  scrollbar-color: var(--scrollbar-color-thumb) var(--scrollbar-color-track);\n  scrollbar-width: thin;\n\n  a {\n    &:link { color: var(--link-color); text-decoration: none;}\n    &:visited { color: var(--link-color); }\n    &:hover { color: var(--link-hover-color); text-decoration: underline;}\n    &:active { color: var(--link-hover-color); }\n  }\n\n\n  /**\n  Material UI overrides\n  */\n\n  .MuiInputBase-root {\n    background-color: var(--theme-color1-button);\n    color: var(--theme-color1-front);\n  }\n\n  .MuiButtonGroup-root {\n    & > .MuiInputBase-root:not(:first-child) {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    & > .MuiInputBase-root:not(:last-child) {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n\n  // Let's remove the padding altogether, and put itt back on a per case basis\n  .MuiTabPanel-root {\n    padding: 0;\n  }\n\n\n}\n\n.contentPane {\n  //padding: 10px;\n  &>* {\n    height: 100%;\n  }\n}\n\n.navbar {\n  padding: 5px;\n}\n\n.paddedPanel {\n  padding: 15px;\n}\n\n.fill {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n\n.hFlow {\n  display: flex;\n  flex-direction: row;\n\n  & > * {\n    flex: 1;\n    min-width: 0;\n    overflow: auto;\n  }\n}\n\n.vFlow {\n  &:not([hidden]) {\n    display: flex;\n  }\n\n  flex-direction: column;\n\n  & > * {\n    //height: inherit;\n    flex: 1;\n    overflow: auto;\n    min-height: 0;\n  }\n\n  .navbar {\n    flex: none;\n  }\n}\n\n\n.absolute-fill {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 5px;\n  overflow: auto;\n}\n\n.react-codemirror2 {\n  height: 100% !important;\n}\n\n.CodeMirror {\n  //border: 1px solid var(--theme-back1);\n  height: 100% !important;\n  width: auto;\n}\n\n.sidenav {\n  flex: none;\n  background-color: var(--theme-color1-back);\n  border-right: 1px solid rgb(19, 40, 74);\n  padding: 5px;\n\n  .sidenav-divider {\n    margin: 5px 0px;\n    border-bottom-width: 1px;\n    border-color: var(--theme-color1-border);\n    //box-shadow: var(--theme-color1-border) 1px 1px 2px;\n  }\n\n  & > button {\n    display: block;\n    border-radius: 10%;\n    margin: 1px;\n    color: var(--theme-color1-front);\n\n    &[aria-selected=\"true\"] {\n      box-shadow: inset 0px 0px 6px 2px var(--theme-color1-border);\n    }\n\n    &:hover {\n      box-shadow: inset 0px 0px 6px 4px var(--theme-color1-hover);\n    }\n  }\n}\n\nsvg {\n  vertical-align: middle;\n}\n\n.retail {\n  @extend .vFlow;\n\n  .dataproviders {\n    flex: none;\n    height: 100px;\n\n    .providerCard {\n      position: relative;\n      overflow: clip;\n      background: var(--theme-back1);\n      margin: 5px;\n      padding: 3px;\n      box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);\n      border: 1px solid var(--theme-back2);\n      border-radius: 3px;\n      max-width: 200px;\n\n      &:hover {\n        border: 1px solid #234087;\n        box-shadow: 3px 3px 3px rgba(0, 0, 113, 0.5);\n      }\n\n      &.selected {\n        height: 110px;\n        border: 1px solid #324c87;\n        border-radius: 3px 3px 0px 0px;\n        border-bottom: none;\n        box-shadow: 3px 3px 3px rgba(0, 0, 113, 0.29);\n        z-index: -1;\n      }\n    }\n  }\n\n  .uploader {\n    background: var(--theme-back1);\n    margin: 5px;\n    padding: 3px;\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);\n    border: 1px solid var(--theme-back2);\n    border-radius: 3px;\n    z-index: 10;\n  }\n}\n\n.podbrowser {\n\n  .scan-results {\n    @extend .paddedPanel;\n    table {\n      border: 1px solid var(--theme-back2);\n    }\n  }\n\n  .topbar {\n    flex: none;\n    //min-height: 25px;\n    background-color: var(--theme-back1);\n    border-bottom: 1px solid var(--theme-back2);\n\n    .filebreadcrumb {\n      display: inline-block;\n      color: var(--theme-front1);\n      border-radius: 2px;\n      background-color: var(--theme-back2);\n      border: 1px solid var(--theme-back2);\n      margin: 3px;\n      padding: 0px 3px;\n    }\n\n    .file_actions {\n      display: inline-block;\n      float: right;\n    }\n  }\n\n  .podbrowser-body {\n    @extend .hFlow;\n\n    .podbrowser-sidenav {\n      @extend .vFlow;\n      flex: 0.5;\n      padding: 8px;\n      border-right: 1px solid var(--theme-border1);\n\n      .podbrowser-sidenav-quicklinks {\n        & > *:hover {\n          background-color: var(--theme-hover);\n        }\n\n        flex: none;\n        border-bottom: 1px solid var(--theme-border2);\n        padding-bottom: 5px;\n        margin-bottom: 5px;\n      }\n\n      .podbrowser-tree {\n        .podbrowser-tree-children {\n          margin-left: 10px;\n        }\n\n        .podbrowser-tree-resource-name {\n          & > * {\n            vertical-align: middle;\n          }\n        }\n      }\n    }\n\n    .podbrowser-resource-viewer {\n      @extend .vFlow;\n      flex: 2;\n      border-right: 1px solid var(--theme-back2);\n\n      .container-viewer {\n        &.details .resource {\n          svg {\n            margin-right: 5px;\n          }\n        }\n\n        &.grid {\n          display: flex;\n          flex-flow: row wrap;\n          align-items: center;\n          align-content: baseline;\n\n          .resource {\n            text-align: center;\n            height: 110px;\n            padding: 3px;\n\n            svg {\n              font-size: var(--resource-icon-size);\n              display: block;\n            }\n\n            div {\n              font-size: 15px;\n              max-width: var(--resource-icon-size);\n              overflow: hidden;\n              text-overflow: ellipsis;\n              word-break: break-all;\n              height: 30px;\n            }\n          }\n\n        }\n\n      }\n    }\n\n    .acrPolicies, .acrMatchers {\n      font-size: 80%;\n\n      th {\n        text-align: center;\n      }\n\n      td {\n\n        max-width: 2em;\n      }\n\n      .MuiCheckbox-root {\n        padding: 0;\n      }\n\n      .policyName {\n        max-width: 100px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-wrap: nowrap;\n      }\n\n      .policyMatchers {\n        padding-left: 15px;\n      }\n\n      .matcherName {\n        display: inline-block;\n        max-width: 100px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        vertical-align: bottom;\n        text-wrap: nowrap;\n      }\n    }\n  }\n\n  .resource {\n    &:hover {\n      background-color: var(--theme-hover);\n    }\n\n    &.selected {\n      background-color: var(--theme-selection);\n    }\n  }\n}\n\n\n.itemsTable {\n  @extend .hFlow;\n\n  .itemsList {\n    @extend .paddedPanel;\n    flex: 1;\n\n    &>div {\n      text-wrap: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &:hover {\n        background-color: var(--theme-hover);\n      }\n\n      &.selected {\n        background-color: var(--theme-selection)\n      }\n    }\n  }\n\n  .itemsDetails {\n    @extend .paddedPanel;\n    flex: 3;\n  }\n}\n\n\n.receiptsTable {\n  @extend .paddedPanel;\n}\n\n.frequencyBar {\n  display: inline-block;\n  border: 1px solid var(--theme-border1);\n  position: relative;\n  vertical-align: middle;\n  margin: 2px 5px;\n\n  &>div {\n    display: inline-block;\n    background-color: green;\n    height: 100%;\n  }\n}\n\n.itemDate {\n  display: inline-block;\n  font-size: 90%;\n  color: var(--theme-front2);\n  margin: 2px 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
